/**
 * This plugin handles client-side errors.
 * Catch all client side error handler
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, _instance, info) => {
    console.error('Nuxt Vue error:', error, info);
  };

  nuxtApp.hook('vue:error', (error, _instance, _info) => {
    console.error('Nuxt vue:error:', error);
  });
});
